import { ref } from 'vue';

export function useOpenOrClosePanel() {
  const isOpen = ref(false);

  function openPanel() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return { isOpen, openPanel, close };
}
